<app-header-content-footer *transloco="let t"
  [headerTitle]="t('rewards')">
  <app-sidenav-content content showBanner>
    <app-rewards-list content></app-rewards-list>
  </app-sidenav-content>
</app-header-content-footer> 
